export const getAllDeliverySlotsData = ({ state }) => state.deliverySlots.deliverySlotsData;
